import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

// TODO: This component can be replaced with button with loading.
const SubmitWithLoading = ({ classes, isSubmitting, text, buttonProps, disabled }) => {
    return (
        <Button type="submit" className={classes.submitButton} disabled={isSubmitting || disabled} {...buttonProps}>
            {text}
            {isSubmitting && <CircularProgress size={24} className={classes.submitProgress} />}
        </Button>
    );
};

SubmitWithLoading.defaultProps = {
    buttonProps: {},
    disabled: false,
};

SubmitWithLoading.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    disabled: PropTypes.bool,
    isSubmitting: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    buttonProps: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])),
};

export default withStyles(styles)(SubmitWithLoading);
